// src/app/_services/popper-state.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PopperStateService {
  private openPopperSubject = new Subject<any>();
  public openPopper$ = this.openPopperSubject.asObservable();

  private currentOpenPopper: any = null;

  registerOpenPopper(popper: any) {
    if (this.currentOpenPopper && this.currentOpenPopper !== popper) {
      this.currentOpenPopper.hide();
    }
    this.currentOpenPopper = popper;
    this.openPopperSubject.next(popper);
  }

//   unregisterOpenPopper(popper: any) {
    // if (this.currentOpenPopper === popper) {
    //   this.currentOpenPopper?.hide();
    //   this.currentOpenPopper = null;
    //   this.openPopperSubject.next(null);
    // }
//   }
}